import { https } from "../http";
import store from "../store";
import { setAddInvoiceSettingLoading, setAllInvoicesSetting,setAllStripeAccounts,setLoading } from "../store/reducers/settinginvoice";
import { showError } from "../utils/index";

// POST  // CREATE INVOICE SETTING
const createInvoicesSetting = async (data, callback) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().post("invoicesetting", data);
    console.log('response in the action',response);
    

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// POST  // CREATE INVOICE SETTING SKYPOINT
const createInvoicesSettingSkypoint = async (data, callback) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().post("invoicesetting/skypoint", data);
    console.log('response in the action',response);
    

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};



//get  INVOICE SETTING

const getInvoicesSetting = async (payload, showLoading = true) => {
  console.log('payload',payload);
  
    try {
      if (showLoading) store.dispatch(setLoading(true));
     let response = await https().get('invoicesetting/get-invoice-setting')

    
        
      if (response?.status === 200) {
        store.dispatch(setAllInvoicesSetting(response?.data));
        store.dispatch(setLoading(false));
        return response
      }

    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
      return false;
    }
  };

//get  INVOICE SETTING SKYPOINT

const getInvoicesSettingSkypoint = async (payload, showLoading = true) => {
  console.log('payload',payload);
  
    try {
      if (showLoading) store.dispatch(setLoading(true));
     let response = await https().get('invoicesetting/skypoint/get-invoice-setting')

    
        
      if (response?.status === 200) {
        store.dispatch(setAllInvoicesSetting(response?.data));
        store.dispatch(setLoading(false));
        return response
      }

    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
      return false;
    }
  };


// EDIT INVOICE SETTING


const EditInvoicesSetting = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().put(`/invoicesetting/${data?.id}`, data);

    if (response?.status === 200) {
        getInvoicesSetting(showLoading);
     
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status)
  }
};

// EDIT INVOICE SETTING SKYPOINT


const EditInvoicesSettingSkypoint = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().put(`/invoicesetting/skypoint/${data?.id}`, data);

    if (response?.status === 200) {
        getInvoicesSettingSkypoint(showLoading);
     
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status)
  }
};



// CREATE STRIPE ACCOUNT

const CreateStripeAccount = async (callback) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().get("invoicesetting/get-stripe-account-link");
    // console.log('response in the action',response);
    

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};




// CREATE STRIPE ACCOUNT SKYPOINT

const CreateStripeAccountSkypoint = async (callback) => {
  try {
    store.dispatch(setAddInvoiceSettingLoading(true));
    let response = await https().get("invoicesetting/skypoint/get-stripe-account-link");
    // console.log('response in the action',response);
    

    if (response?.status === 200) {
      //  getAllBillingConsumers()
      // getReports(false);
      callback?.();
    }

    return response
  } catch (error) {
    store.dispatch(setAddInvoiceSettingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};



// GET  STRIPE LiNK ACCOUNT


const getStripAccountForInovices = async (payload, showLoading = true) => {
  console.log('payload',payload);
  
    try {
      if (showLoading) store.dispatch(setLoading(true));
     let response = await https().get('invoicesetting/links-stripe-accounts')

    
        
      if (response?.status === 200) {
        store.dispatch(setAllStripeAccounts(response?.data));
        store.dispatch(setLoading(false));
        return response
      }

    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
      return false;
    }
  };

// GET  STRIPE LiNK ACCOUNT SKYPOINT


const getStripAccountForInovicesSkypoint = async (payload, showLoading = true) => {
  console.log('payload',payload);
  
    try {
      if (showLoading) store.dispatch(setLoading(true));
     let response = await https().get('invoicesetting/skypoint/links-stripe-accounts')

    
        
      if (response?.status === 200) {
        store.dispatch(setAllStripeAccounts(response?.data));
        store.dispatch(setLoading(false));
        return response
      }

    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
      return false;
    }
  };



export {
    createInvoicesSetting,
    getInvoicesSetting,
    EditInvoicesSetting,
    CreateStripeAccount,
    getStripAccountForInovices,
    createInvoicesSettingSkypoint,
    getInvoicesSettingSkypoint,
    EditInvoicesSettingSkypoint,
    getStripAccountForInovicesSkypoint,
    CreateStripeAccountSkypoint
}